module.exports = __webpack_public_path__ + "static/media/outlet1.100dea4f.png";